import { hFetch } from '@/lib/hfetch';

export type PipelineReviewAiDigestTheme = {
  theme: string;
  recommended_action: string;
  evidence_count: number;
};

export type PipelineReviewAiDigestQuestion = {
  question_id: number;
  question: string;
  response_count: number;
  summary: string | null;
  primary_action: string | null;
  trends: PipelineReviewAiDigestTheme[];
};

export type PipelineReviewAiDigestRecord = {
  id: number;
  cycle_start_at: string;
  cycle_end_at: string;
  review_count: number;
  response_count: number;
  model_version: string | null;
  created_at: string;
  summary: string | null;
  per_question_trends: PipelineReviewAiDigestQuestion[];
};

export const getRecentDigest = async () => {
  return await hFetch<PipelineReviewAiDigestRecord | null>({
    url: '/api/pipeline_review_ai_digests',
  });
};
